module.exports = __webpack_public_path__ + "media/images/products/category/10-958d0c6e5e27ea1753140c6b0a5ecbee.jpg";